"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFieldTitle = exports.useNativeComponent = exports.shouldShowTitle = exports.shouldShowErrors = exports.parseChildKeys = void 0;

var _form = require("@widergy/web-utils/lib/form");

var FORMS = _interopRequireWildcard(require("../../constants/fieldTypes"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var parseChildKeys = function parseChildKeys(childKeys) {
  try {
    return JSON.parse(childKeys);
  } catch (e) {
    return childKeys;
  }
};

exports.parseChildKeys = parseChildKeys;

var shouldShowErrors = function shouldShowErrors(meta, type) {
  return [FORMS.FIELD_TEXT, FORMS.FIELD_DATE, FORMS.FIELD_PHONE, FORMS.FIELD_EMAIL, FORMS.FIELD_SELECT, FORMS.FIELD_PASSWORD, FORMS.FIELD_CREDIT_CARD, FORMS.FIELD_ANIMATED_CREDIT_CARD, FORMS.FIELD_SKETCH, FORMS.FIELD_IMAGE_RADIO, FORMS.FIELD_CUIT, FORMS.FIELD_CHIP, FORMS.FIELD_MAP, FORMS.FIELD_AUTOCOMPLETE].indexOf(type) === -1 && (0, _form.shouldShowErrors)(meta);
};

exports.shouldShowErrors = shouldShowErrors;

var shouldShowTitle = function shouldShowTitle(field) {
  if (field.configuration && field.configuration.ignore_title) return false;
  return [FORMS.FIELD_LABEL, FORMS.FIELD_URL, FORMS.FIELD_CHECKBOX, FORMS.FIELD_CAPTCHA, FORMS.FIELD_TEXT, FORMS.FIELD_EMAIL, FORMS.FIELD_SELECT, FORMS.FIELD_PHONE, FORMS.FIELD_CREDIT_CARD, FORMS.FIELD_ANIMATED_CREDIT_CARD, FORMS.FIELD_PASSWORD, FORMS.FIELD_CUIT, FORMS.FIELD_CHIP, FORMS.FIELD_AUTOCOMPLETE, FORMS.FIELD_DATE].indexOf(field.type) === -1;
};

exports.shouldShowTitle = shouldShowTitle;

var useNativeComponent = function useNativeComponent(field) {
  return [FORMS.FIELD_IMAGE_LABEL, FORMS.FIELD_URL].indexOf(field.type) !== -1;
};

exports.useNativeComponent = useNativeComponent;

var getFieldTitle = function getFieldTitle(field) {
  return field.required ? "".concat(field.title, " *") : field.title;
};

exports.getFieldTitle = getFieldTitle;